import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PaymentComplianceAlertModalService } from 'src/app/@core/services/payment-compliance-alert-modal.service';
import { ColumnTable } from 'src/app/models/column-table';
import { Order } from 'src/app/models/order';
import { Paging } from 'src/app/models/page';
import { PaymentMethodType } from 'src/app/models/payment-method-type';
import { ProductCart } from 'src/app/models/product-cart';
import { PaymentTransactionRequestModel } from 'src/app/models/request/PaymentTransactionRequestModel';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { PaymentTypesService } from 'src/app/services/payment-types.service';

@Component({
  selector: 'pay-invoice-step',
  templateUrl: './pay-invoice-step.component.html',
  styleUrls: ['./pay-invoice-step.component.sass']
})
export class PayInvoiceStepComponent implements OnInit, OnChanges {

  constructor(
    private paymentMethodService: PaymentTypesService,
    private configurationService: ConfigurationService,
    private readonly paymentComplianceModalService: PaymentComplianceAlertModalService) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadProductsCart();
    this.loadPayments();
  }

  async ngOnInit(): Promise<void> {
    this.paymentMethods = (await this.paymentMethodService.getPaymentMethods(this.configurationService.readSelectedBranchAndSalesOrg().salesOrg.code).toPromise()).response.content;
    // this.loadProductsCart();
  }


  paymentMethods: Array<PaymentMethodType> = [];
  productsCart = new Paging<Array<ProductCart>>([]);

  @Input()
  paymentRequest: Array<PaymentTransactionRequestModel> = [];

  @Input()
  payments = new Paging<Array<{ name: string, amount: number, identifier: string }>>([]);

  @Input()
  order: Order = new Order();

  @Output()
  doPay: EventEmitter<Array<PaymentTransactionRequestModel>> = new EventEmitter<Array<PaymentTransactionRequestModel>>();

  getProductCartHeaders(): Array<ColumnTable> {
    return [
      new ColumnTable("amount", "#", { type: "number", iconClass: "fa fa-shopping-cart", isIcon: true }),
      new ColumnTable("productCode", "Código", { isSmall: true }),
      new ColumnTable("description", "Descripción", { isSmall: true }),
      new ColumnTable("serial", "Serie", { type: "badge" }),
      new ColumnTable("price", "Sub-Total", { type: "currency" }),
      new ColumnTable("discountTotal", "Descuento", { type: "currency" }),
      new ColumnTable("taxTotal", "Impuesto", { type: "currency" }),
      new ColumnTable("total", "Total", { type: "currency" })
    ]
  }

  getPaymentHeaders(): Array<ColumnTable> {
    return [
      new ColumnTable('name', 'Tipo Pago'),
      new ColumnTable('amount', 'Total', { type: 'currency' }),
      //new ColumnTable('applied', 'Aplicado', { type: 'currency' }),
      new ColumnTable('identifier', 'Identificador')
    ];
  }
  loadProductsCart() {
    this.productsCart = new Paging(this.order.orderEntryList.map(o => {
      let result = new ProductCart();
      result.productCode = o.productCode;
      result.description = o.productName;
      result.amount = o.totalQuantity
      result.serial = o.serialNumber;
      result.price = o.totals.grossTotal;
      result.discountTotal = o.totals.discountTotal;
      result.taxTotal = o.totals.taxTotal;
      result.total = o.totals.netTotal;

      return result;
    }))
  }

  async pay() {
    const payments = this.paymentRequest.flatMap(m => m.paymentsRequestModel.payments).concat(this.paymentRequest.flatMap(m => m.chargeNotePaymentsRequestModel.payments));
    if (await this.paymentComplianceModalService.validatePaymentCompliance(null, this.order.customerCode, this.order.branchCode, this.order.salesOrgCode, this.order.condition, payments)) {
      return;
    }
    this.doPay.emit(Array.from(new Set(this.paymentRequest)));
  }

  loadPayments() {
    this.payments = new Paging(this.paymentRequest.flatMap(m => [...m.paymentsRequestModel.payments, m.chargeNotePaymentsRequestModel.payments]).flatMap(m => m).map(x => {
      var method = this.getPaymentMethod(x.paymentMethodCode).name;
      return {
        amount: x.amount,
        name: `${x.amount < 0 ? 'Cambio ' : ''}${method}`,
        identifier: x.receiptNumber
      }
    }));


  }
  getPaymentMethod(paymentMethodCode: string): PaymentMethodType {
    return this.paymentMethods.find(f => f.code == paymentMethodCode) || new PaymentMethodType();
  }
}
